import "./OutputDocuments.scss";

import classNames from "classnames";
import { BsDropdown } from "components/Bootstrap/BsDropdown";
import { OutputDocumentViewModel } from "models/OutputDocumentViewModel";
import { useAgendaItem } from "providers";
import { useBoard } from "providers";
import { useMeeting } from "providers";
import { useOutputDocuments } from "providers";
import { useOutputDocumentsPanel } from "providers";
import { useTranslations } from "providers";
import React from "react";

export const OutputDocumentsAgendaItem: React.FC = () => {
  const i18n = useTranslations();
  const { canGenerateDocuments } = useBoard();

  const { meetingId } = useMeeting();
  const { selectAgendaItemId } = useAgendaItem();
  const { isLoading, agendaItemLinks } = useOutputDocuments();
  const { onSelectDocument } = useOutputDocumentsPanel();

  const isAgendaItemPage = window.location.pathname.toLowerCase().includes("/agendaitems");
  const isEnabled = canGenerateDocuments && isAgendaItemPage && !!selectAgendaItemId;

  if (!isEnabled) {
    return null;
  }

  if (!meetingId) {
    return null;
  }

  return (
    <BsDropdown
      name="OutputDocumentsAgendaItem"
      menuClass="dropdown-with-icon"
      displayValue={i18n.OutputDocuments_Button_AgendaItem}
      items={agendaItemLinks}
      disabled={isLoading}
      onClick={(item) => {
        const vm = item as OutputDocumentViewModel;
        if (!vm) return;
        onSelectDocument(vm, meetingId, selectAgendaItemId);
      }}
      renderItem={(item) => {
        const vm = item as OutputDocumentViewModel;
        if (!vm) return null;

        const { description, title, iconClass, disabled, disabledMessage } = vm;

        return (
          <div className="d-flex">
            <div className="icon-start">{iconClass && <i className={classNames(iconClass)} />}</div>

            {description && description != "-" ? (
              <div className="global-tooltip-trigger" title={description}>
                {title}
              </div>
            ) : (
              <div>{title}</div>
            )}

            <div className="icon-end">
              {disabled && disabledMessage && (
                <i className="ms-Icon ms-Icon--StatusCircleBlock global-tooltip-trigger" title={disabledMessage} />
              )}
            </div>
          </div>
        );
      }}
    />
  );
};
